import { IconButton, Tooltip } from "@mui/material";
import {
  gridDetailPanelExpandedRowIdsSelector,
  gridDetailPanelExpandedRowsContentCacheSelector,
  GridRenderCellParams,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { MdsContract } from "@sinch/icons";
import { isNotNilOrEmpty } from "ramda-adjunct";
import React, { MouseEventHandler, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { MdsIcon } from "@sinch/components";
import { Row } from "@sinch/components/application/RatesCompositionTable/RatesCompositionTable";

export function CustomDetailPanelToggle(props: GridRenderCellParams<Row>) {
  const { t } = useTranslation(["common", "draft"]);
  const { id, row } = props;
  const apiRef = useGridApiContext();

  // To avoid calling ´getDetailPanelContent` all the time, the following selector
  // gives an object with the detail panel content for each row id.
  const contentCache = useGridSelector(apiRef, gridDetailPanelExpandedRowsContentCacheSelector);

  const expandedRowIds = useGridSelector(apiRef, gridDetailPanelExpandedRowIdsSelector);

  const isExpanded = expandedRowIds.has(id);

  // If the value is not a valid React element, it means that the row has no detail panel.
  const hasDetail =
    React.isValidElement(contentCache[id]) &&
    (row.priceDetails?.some(({ components }) => isNotNilOrEmpty(components)) ||
      row.wageDetails?.some(({ components }) => isNotNilOrEmpty(components)));

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      apiRef.current.toggleDetailPanel(id);
      event.stopPropagation();
    },
    [apiRef, id]
  );

  if (!hasDetail) {
    return <span />;
  }
  return (
    <Tooltip title={t("MarginTable.componentComposition")}>
      <IconButton onClick={handleClick} size="small" tabIndex={-1}>
        <MdsIcon color={isExpanded ? "info" : "inherit"} cursor="pointer" fontSize="small" icon={MdsContract} />
      </IconButton>
    </Tooltip>
  );
}
